import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { getPopularArticles } from '@/mocks/articles';
import { popularTags } from '@/mocks/categories';

export default function Sidebar() {
  const popularArticles = getPopularArticles(6);

  return (
    <aside className="space-y-6">
      <div className="bg-background-100 rounded-xl p-5">
        <h3 className="text-base font-bold font-heading text-foreground-950 mb-4">
          热门排行
        </h3>
        <div>
          {popularArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="compact" />
          ))}
        </div>
      </div>

      <div className="bg-background-100 rounded-xl p-5">
        <h3 className="text-base font-bold font-heading text-foreground-950 mb-4">
          热门标签
        </h3>
        <div className="flex flex-wrap gap-2">
          {popularTags.map((tag) => (
            <Link
              key={tag}
              to={`/category/heixan-baoliao`}
              className="px-3 py-1.5 bg-background-50 text-foreground-600 text-xs rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-background-100 rounded-xl p-5">
        <h3 className="text-base font-bold font-heading text-foreground-950 mb-4">
          关于51cg
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3">
          51cg吃瓜网（51cg.fun）是国内领先的娱乐八卦与热点资讯聚合平台。我们致力于为用户提供最新、最全、最真实的吃瓜内容。
        </p>
        <Link
          to="/about"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
        >
          了解更多
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>
    </aside>
  );
}